export const getScoreColor = (score: number, benchmark: number) => {
  if (score < 40) return 'bg-[#E8324A]';
  else if (score < benchmark) return 'bg-[#FFA958]';
  else return 'bg-[#0AA65D]';
};

export const getTextColor = (color: string) => `text-[${color.slice(4, 11)}]`;
